import React from 'react';
import { Text } from '@fluentui/react';
import SystemClient from '../../../../system/SystemClient';
import MessageCourier from '../../../../lib/MessageCourier';
import { DefaultButton, Label, Pivot, PivotItem } from '@fluentui/react';
import PlanillaPartidoForm from '../../PlanillaPartidoForm';
import { CampoJuegoSelectorInput } from '../../../CampoJuego/CampoJuegoSelector';
import { useCustomInput } from '../../../../common/custom-hooks/useCustomInput';
import useAsyncData from '../../../../common/custom-hooks/useAsyncData';
import { Partido } from '../../../../system/Partido/Partido';
import { Categoria } from '../../../../system/Categoria/Categoria';
import { PlanillaPartidoReglaJugadorDisponibleCategoriasInferior } from '../../../../system/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
import { TeamCardForConfeccion } from './ConfeccionPlanillaPartido';
import CustomInputIfc from '../../../../lib/FormValidator/Form/CustomInputIfc';
import { DatePickerInput } from '../../../../lib/FormValidator/Form/DatePickerInput';
import { HourSelector } from '../../../Common/HourSelector';
import { ArbitroSelectorInput } from '../../../Arbitro/ArbitroSelector';
import { PlanillaPartidoContext } from '../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { OficialMesaSelectorInput } from '../../../OficialMesa/OficialMesaSelector';
import ConfeccionPlanillaPartidoTeam from './ConfeccionPlanillaPartidoTeam';
import OficialMesaNoRegistradoView from './OficialMesaNoRegistradoView';
import { OficialNRCardForConfeccion } from './CardUtils/OficialNRCardForConfeccion';
import ToggleInput from '../../../../lib/FormValidator/Form/ToggleInput';
import { Icon, Toggle } from 'office-ui-fabric-react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../common/routes';
import { Torneo } from '../../../../system/Torneo/Torneo';
import { Usuario } from '../../../../system/Usuario/Usuario';
import { Federacion } from '../../../../system/Federacion/Federacion';
import { FederacionSelector } from '../../../Federacion/FederacionSelector';
import InputField from '../../../../lib/FormValidator/Form/InputField';
import { CesionPuntos } from '../../../Common/CesionPuntos';
import useAsyncDataCourier from '../../../../common/custom-hooks/useAsyncDataCourier';
import { useContainerStyle } from '../../../../common/custom-hooks/useStyles';

interface IConfeccionPlanillaPartidoView {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  form: PlanillaPartidoForm;
  partido: Partido;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  context: PlanillaPartidoContext;
  rules: PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[];
  torneo: Torneo;
  user: Usuario;
}

const ConfeccionPlanillaPartidoView = ({
  system,
  courier,
  changeBlockUI,
  form,
  partido,
  onBlurCustomInput,
  context,
  rules,
  user,
  torneo,
}: IConfeccionPlanillaPartidoView) => {
  const campoJuegoInput = useCustomInput(() => form.getCjidInput(), [form]);
  const fechaHoraInicioInput = useCustomInput(() => form.getFechaHoraInicioInput(), [form]);
  const arbitroId1Input = useCustomInput(() => form.getArbid1Input(), [form]);
  const arbitroObj1Input = useCustomInput(() => form.getArbitro1Input(), [form]);
  const arbitroId2Input = useCustomInput(() => form.getArbid2Input(), [form]);
  const arbitroObj2Input = useCustomInput(() => form.getArbitro2Input(), [form]);
  const oficialMesaIdLocalInput = useCustomInput(() => form.getOfmidLocalInput(), [form]);
  const oficialMesaIdVisitanteInput = useCustomInput(() => form.getOfmidVisitanteInput(), [form]);
  const diferidoInput = useCustomInput(() => form.getDiferidoInput(), [form]);
  const puedeEmpatarInput = useCustomInput(() => form.getPuedeEmpatarInput(), [form]);
  const urlTransmisionInput = useCustomInput(() => form.getUrlTransmisionInput(), [form]);

  const navigate = useNavigate();

  const [equipoId, setEquipoId] = React.useState<string>();

  const categorias = useAsyncData(() => system.getCategoriaSystem().getListForDropdown(), []);

  const [showJugadores, setShowJugadores] = React.useState<boolean>(true);
  const [showOficiales, setShowOficiales] = React.useState<boolean>(true);
  const [hasLocalNR, setHasLocalNR] = React.useState<boolean>(false);
  const [hasVisitanteNR, setHasVisitanteNR] = React.useState<boolean>(false);
  const [localIdx, setLocalIdx] = React.useState<number>(0);
  const [visitanteIdx, setVisitanteIdx] = React.useState<number>(0);
  const [federacionFilter, setFederacionFilter] = React.useState<Federacion | undefined>(undefined);
  const getHasLocalNR = () => {
    let local: boolean = false;
    if (
      form.getOficialesMesaNoRegistradosInput().getValue() &&
      form.getOficialesMesaNoRegistradosInput().getValue().length > 0
    ) {
      form
        .getOficialesMesaNoRegistradosInput()
        .getValue()
        .forEach((oficialNR: PlanillaPartidoOficialMesaNoRegsitrado, idx: number) => {
          if (+oficialNR.getEqid() == +partido.getEqidLocal()!) {
            setLocalIdx(idx);
            local = true;
          }
        });
    }
    setHasLocalNR(local);
  };
  const getHasVisitanteNR = () => {
    let visitante: boolean = false;
    if (
      form.getOficialesMesaNoRegistradosInput().getValue() &&
      form.getOficialesMesaNoRegistradosInput().getValue().length > 0
    ) {
      form
        .getOficialesMesaNoRegistradosInput()
        .getValue()
        .forEach((oficialNR: PlanillaPartidoOficialMesaNoRegsitrado, idx: number) => {
          if (+oficialNR.getEqid() == +partido.getEqidVisitante()!) {
            visitante = true;
            setVisitanteIdx(idx);
          }
        });
    }
    setHasVisitanteNR(visitante);
  };

  const deleteOficial = (oficial: PlanillaPartidoOficialMesaNoRegsitrado) => {
    const oficialesNoRegistrados = [...form.getOficialesMesaNoRegistradosInput().getValue()];
    const idx = oficialesNoRegistrados.findIndex(
      (onr: PlanillaPartidoOficialMesaNoRegsitrado) =>
        onr.getApellido() === oficial.getApellido() &&
        onr.getDni() === oficial.getDni() &&
        onr.getNombre() === oficial.getNombre()
    );
    if (oficialesNoRegistrados[idx].getId()) {
      oficialesNoRegistrados[idx].setDeleted(true);
    } else {
      oficialesNoRegistrados.splice(idx, 1);
    }
    form.getOficialesMesaNoRegistradosInput().setValue(oficialesNoRegistrados);
    getHasLocalNR();
    getHasVisitanteNR();
    setEquipoId('');
  };

  React.useEffect(() => {
    getHasLocalNR();
    getHasVisitanteNR();
  }, [form.getOficialesMesaNoRegistradosInput().getValue(), partido]);

  const parejasArbitro1 = useAsyncDataCourier(
    () =>
      arbitroId1Input.getValue()
        ? system.getArbitroParejaSystem().getPairs(String(arbitroId1Input.getValue()), '')
        : Promise.resolve([]),
    [arbitroId1Input.getValue()],
    courier,
    changeBlockUI
  );

  React.useEffect(() => {
    if (!arbitroId2Input.getValue() && parejasArbitro1 && parejasArbitro1.length > 0) {
      parejasArbitro1.forEach((p) => {
        if (p.getActivo()) {
          const a2 = +p.getArbid1() === +arbitroId1Input.getValue() ? +p.getArbid2() : +p.getArbid1();
          arbitroId2Input.setValue(a2);
        }
      });
    }
  }, [parejasArbitro1]);

  const containerStyle = useContainerStyle();

  return (
    <div>
      {partido && (
        <div className="ms-Grid " style={containerStyle} dir="ltr">
          <div className="ms-Grid-row padding-1">
            <Pivot aria-label="">
              <PivotItem headerText="Básicos" itemKey={'Basicos'}>
                <div className="ms-Grid-col ms-sm12 ">
                  <div className="ms-Grid-row mt-2">
                    <div className="ms-Grid-col ms-sm12 ">
                      <Text className="mb-1" variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                        Información básica del partido
                      </Text>
                    </div>
                  </div>
                  <div className="ms-Grid-row mt-2">
                    {form.getPartidoInput().getValue().getTorneo()?.isMultifederacion() &&
                      (user.isConfederacionResponsableUser() ||
                        user.isConfederacionSupervisorUser() ||
                        user.isAdminUser()) && (
                        <div className="ms-Grid-col ms-sm3">
                          <FederacionSelector
                            system={system}
                            courier={courier}
                            onSelect={(f) => {
                              setFederacionFilter(f);
                              campoJuegoInput.setValue(null);
                            }}
                            selected={
                              federacionFilter
                                ? [federacionFilter.getId()!]
                                : [String(form.getPartidoInput().getValue().getCampoJuego()!.getFedid())]
                            }
                            label="Federación del campo de juego"
                            onDelete={() => setFederacionFilter(undefined)}
                          ></FederacionSelector>
                        </div>
                      )}

                    <div
                      className={
                        form.getPartidoInput().getValue().getTorneo()?.isMultifederacion()
                          ? 'ms-Grid-col ms-sm3'
                          : 'ms-Grid-col ms-sm6'
                      }
                    >
                      <CampoJuegoSelectorInput
                        system={system}
                        courier={courier}
                        input={campoJuegoInput}
                        onBlurCustomInput={onBlurCustomInput}
                        providedList={context.camposJuegoDisponibles.filter((cj) => {
                          const esMultifederacion = form
                            .getPartidoInput()
                            .getValue()
                            .getTorneo()
                            ?.isMultifederacion();
                          if (esMultifederacion && federacionFilter) {
                            return +cj.getFedid() === +federacionFilter.getId()!;
                          } else {
                            return true;
                          }
                        })}
                      ></CampoJuegoSelectorInput>
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm3">
                      <DatePickerInput
                        input={fechaHoraInicioInput}
                        label={'Fecha'}
                        onBlur={onBlurCustomInput}
                      />
                    </div>
                    <div className="ms-Grid-col ms-sm2">
                      <HourSelector
                        onChange={(val) => {
                          if (form.getHorario() !== val) {
                            const copiaFecha = new Date(fechaHoraInicioInput.getValue());
                            copiaFecha.setHours(+val.split(':')[0]);
                            copiaFecha.setMinutes(+val.split(':')[1]);
                            fechaHoraInicioInput.setValue(copiaFecha);
                            onBlurCustomInput(fechaHoraInicioInput);
                          }
                        }}
                        hour={+form.getHorario().split(':')[0]}
                        minute={+form.getHorario().split(':')[1]}
                        useHalf
                        useLabel
                      />
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Label>En vivo</Label>
                      <ToggleInput
                        input={diferidoInput}
                        onBlur={onBlurCustomInput}
                        offText={'No'}
                        onText={'Si'}
                      ></ToggleInput>
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm3">
                      <Label>Primer arbitro</Label>
                      <ArbitroSelectorInput
                        system={system}
                        courier={courier}
                        input={arbitroId1Input}
                        onBlurCustomInput={onBlurCustomInput}
                        hideLabel
                        providedList={context.arbitrosDisponibles.filter(
                          (a) => a.getId() !== arbitroId2Input.getValue()
                        )}
                        onChangeExtended={(a) => arbitroObj1Input.setValue(a)}
                      ></ArbitroSelectorInput>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Label>Segundo arbitro</Label>
                      <ArbitroSelectorInput
                        system={system}
                        courier={courier}
                        input={arbitroId2Input}
                        onBlurCustomInput={onBlurCustomInput}
                        hideLabel
                        providedList={context.arbitrosDisponibles.filter(
                          (a) => a.getId() !== arbitroId1Input.getValue()
                        )}
                        onChangeExtended={(a) => arbitroObj2Input.setValue(a)}
                        onDelete={() => {
                          arbitroId2Input.setValue(0);
                          arbitroObj2Input.setValue(null);
                        }}
                      ></ArbitroSelectorInput>
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm3">
                      <Label>Oficial de mesa local</Label>
                      <OficialMesaSelectorInput
                        system={system}
                        courier={courier}
                        input={oficialMesaIdLocalInput}
                        onBlurCustomInput={onBlurCustomInput}
                        hideLabel
                        providedList={context.oficialesMesaDisponibles.filter(
                          (o) => o.getId() !== oficialMesaIdVisitanteInput.getValue()
                        )}
                        disabled={!(String(partido.getEqidLocal()) != String(equipoId) && !hasLocalNR)}
                        onDelete={() => {
                          oficialMesaIdLocalInput.setValue(0);
                        }}
                      ></OficialMesaSelectorInput>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Label>Oficial de mesa visitante</Label>
                      <OficialMesaSelectorInput
                        system={system}
                        courier={courier}
                        input={oficialMesaIdVisitanteInput}
                        onBlurCustomInput={onBlurCustomInput}
                        hideLabel
                        providedList={context.oficialesMesaDisponibles.filter(
                          (o) => o.getId() !== oficialMesaIdLocalInput.getValue()
                        )}
                        disabled={
                          !(String(partido.getEqidVisitante()) != String(equipoId) && !hasVisitanteNR)
                        }
                        onDelete={() => {
                          oficialMesaIdVisitanteInput.setValue(0);
                        }}
                      ></OficialMesaSelectorInput>
                    </div>
                  </div>
                  <div className="ms-Grid-row mt-2">
                    {!oficialMesaIdLocalInput.getValue() ? (
                      <div className="ms-Grid-col ms-sm3">
                        {!hasLocalNR ? (
                          <DefaultButton onClick={() => setEquipoId(String(partido.getEqidLocal()))}>
                            Oficial de mesa Local no registrado
                          </DefaultButton>
                        ) : (
                          <>
                            <OficialNRCardForConfeccion
                              system={system}
                              context={context}
                              // oficialNR={form.getOficialesMesaNoRegistradosInput().getValue()[localIdx]}
                              oficialNR={
                                form.getOficialNoRegistradoByEquipoId(String(partido.getEqidLocal()))!
                              }
                              deleteOficial={deleteOficial}
                            />
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="ms-Grid-col ms-sm3" />
                    )}
                    {!oficialMesaIdVisitanteInput.getValue() ? (
                      <div className="ms-Grid-col ms-sm3">
                        {!hasVisitanteNR ||
                        !!!form.getOficialNoRegistradoByEquipoId(String(partido.getEqidVisitante())) ? (
                          <DefaultButton onClick={() => setEquipoId(String(partido.getEqidVisitante()))}>
                            Oficial de mesa visitante no registrado
                          </DefaultButton>
                        ) : (
                          <OficialNRCardForConfeccion
                            system={system}
                            context={context}
                            // oficialNR={form.getOficialesMesaNoRegistradosInput().getValue()[visitanteIdx]}
                            oficialNR={
                              form.getOficialNoRegistradoByEquipoId(String(partido.getEqidVisitante()))!
                            }
                            deleteOficial={deleteOficial}
                          />
                        )}
                      </div>
                    ) : (
                      <div className="ms-Grid-col ms-sm3"></div>
                    )}
                  </div>
                  {equipoId ? (
                    <OficialMesaNoRegistradoView
                      system={system}
                      courier={courier}
                      changeBlockUI={changeBlockUI}
                      form={form}
                      partido={partido}
                      context={context}
                      eqId={equipoId}
                      setEquipoId={setEquipoId}
                    />
                  ) : null}
                  <div className="ms-Grid-row mt-2">
                    <div className="ms-Grid-col ms-sm3">
                      <Label>El resultado final del partido, puede ser empate?</Label>
                      <ToggleInput
                        input={puedeEmpatarInput}
                        offText="No"
                        onText="Si"
                        onBlur={onBlurCustomInput}
                      />
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm3">
                      <InputField
                        input={urlTransmisionInput}
                        label={'URL de la transmision'}
                        onBlur={onBlurCustomInput}
                      />
                    </div>
                  </div>
                  <CesionPuntos
                    partido={partido}
                    system={system}
                    courier={courier}
                    changeBlockUI={changeBlockUI}
                    onCesionOk={() => {
                      navigate(routes.planilla_partido_programado.route);
                    }}
                    onCesionAmbosOk={() => {
                      navigate(routes.planilla_partido_programado.route);
                    }}
                  ></CesionPuntos>
                </div>
              </PivotItem>
              <PivotItem headerText="Local" itemKey={'Local'}>
                {categorias && (
                  <ConfeccionPlanillaPartidoTeam
                    system={system}
                    courier={courier}
                    changeBlockUI={changeBlockUI}
                    form={form}
                    partido={partido}
                    onBlurCustomInput={onBlurCustomInput}
                    context={context}
                    equipo={form.getPartidoInput().getValue().getLocal()}
                    showJugadores={showJugadores}
                    setShowJugadores={(b: boolean) => setShowJugadores(b)}
                    showOficiales={showOficiales}
                    setShowOficiales={(b: boolean) => setShowOficiales(b)}
                    contextListJugador={context.jugadoresPosiblesEquipoLocal}
                    contextListEntrenador={context.oficialesEquipoLocal}
                    rules={rules}
                    categorias={categorias}
                    torneo={torneo}
                  ></ConfeccionPlanillaPartidoTeam>
                )}
              </PivotItem>
              <PivotItem headerText="Visitante" itemKey={'Visitante'}>
                {categorias && (
                  <ConfeccionPlanillaPartidoTeam
                    system={system}
                    courier={courier}
                    changeBlockUI={changeBlockUI}
                    form={form}
                    partido={partido}
                    onBlurCustomInput={onBlurCustomInput}
                    context={context}
                    equipo={form.getPartidoInput().getValue().getVisitante()}
                    showJugadores={showJugadores}
                    setShowJugadores={(b: boolean) => setShowJugadores(b)}
                    showOficiales={showOficiales}
                    setShowOficiales={(b: boolean) => setShowOficiales(b)}
                    contextListJugador={context.jugadoresPosiblesEquipoVisitante}
                    contextListEntrenador={context.oficialesEquipoVisitante}
                    rules={rules}
                    categorias={categorias}
                    torneo={torneo}
                  ></ConfeccionPlanillaPartidoTeam>
                )}
              </PivotItem>
            </Pivot>{' '}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfeccionPlanillaPartidoView;
